import axios from "axios";
import AuthService from "../login/auth.service";
// import { transferencias } from "../../components/generico/utils/UrlAPI";

import { transferencias } from "../../components/generico/utils/UrlAPI";

class InactivarPinTransaccionalService {
  async inactivarPin(_pin) {

    var data = JSON.stringify({
      pin: _pin,
      canal: "WEB"
      // cedulaSocio: AuthService.getSocio().numeroCedula.trim(),
    });

    var config = {
      method: "post",
      // url: "inactivar-pin/?access_token=" + AuthService.getCurrentToken(),
      url: transferencias + "pines/inactivar",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data: data,
    };
    return await axios(config);
  }

}
export default new InactivarPinTransaccionalService();
